export default __webpack_public_path__ + "static/media/57.cbabfd95.png";